import { useContext, useState, useSyncExternalStore } from "react"
import { BenefitEditorContext, useBenefitDraftState } from "./benefitEditorContext"

const noSubscribe = () => () => {}

/** Income uses the same key/field/value contract as every other workspace editor. */
export const useBenefitIncomeDraft = useBenefitDraftState

/** A workflow preference only; existing saved source types always render from the workspace. */
export function useIncomeHistoryPreference(initial: number) {
  const controller = useContext(BenefitEditorContext)
  const [local, setLocal] = useState(initial)
  const stored = useSyncExternalStore(controller?.store.subscribe ?? noSubscribe,
    () => controller?.incomeHistoryType() ?? null, () => null)
  return [controller ? stored ?? initial : local, (incomeType: number) => {
    if (controller) return controller.confirmIncomeHistoryType(incomeType)
    setLocal(incomeType)
    return true
  }] as const
}
